export const convertToSpamVolume = (volume, spam) => {
  return volume ? (volume * (1 + spam / 100)).toFixed(2) : 0;
};

export const computeDataCompWithSpam = (dataComp, spam) => {
  const newDataComp = [...dataComp];
  Object.keys(newDataComp[0]).forEach(key => {
      const dataKey = newDataComp[0][key] ? { prev: newDataComp[0][key].prev * 1, next: newDataComp[0][key].next * 1, name: newDataComp[0][key].name, isNotExact: newDataComp[0][key].isNotExact } : { prev: 0, next: 0, name: '', isNotExact: false };
      newDataComp[0][key] = { prev: dataKey.prev * 1, next: spam ? convertToSpamVolume(dataKey.prev, spam) * 1 : dataKey.prev * 1, name: newDataComp[0][key].name, isNotExact: newDataComp[0][key].isNotExact };
    }
  );
  return newDataComp;
};
